// The plain header's center nav targets. Split into its own data module (no
// component imports, no Radix, no icons) so BOTH the eager nav-link strip in
// Header.tsx and the lazily-loaded MobileNav can read it without the menu chunk
// pulling Header's first paint along with it. Both lists are fixed/hardcoded on
// purpose — no registry-driven generation.
export const navLinks = [
  { label: `Home`, to: `/` },
  { label: `Explore`, to: `/trips/explore` },
  { label: `Blog`, to: `/blogs` },
]
